import React, { useState } from 'react';
import {
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
  MDBBtn,
  MDBIcon
} from 'mdb-react-ui-kit';

const MessageBox = ({ show, onClose, title, message, type = 'info' }) => {
  if (!show) return null;

  const getIcon = () => {
    switch (type) {
      case 'success':
        return 'check-circle';
      case 'error':
        return 'exclamation-circle';
      case 'warning':
        return 'exclamation-triangle';
      case 'info':
      default:
        return 'info-circle';
    }
  };

  const getColor = () => {
    switch (type) {
      case 'success':
        return 'success';
      case 'error':
        return 'danger';
      case 'warning':
        return 'warning';
      case 'info':
      default:
        return 'info';
    }
  };

  return (
    <MDBModal open={show} tabIndex='-1' staticBackdrop>
      <MDBModalDialog centered>
        <MDBModalContent>
          <MDBModalHeader>
            <MDBModalTitle>
              <MDBIcon icon={getIcon()} className={`me-2 text-${getColor()}`} />
              {title || 'Message'}
            </MDBModalTitle>
          </MDBModalHeader>
          <MDBModalBody>
            <p className="mb-0">{message}</p>
          </MDBModalBody>
          <MDBModalFooter>
            <MDBBtn color={getColor()} onClick={onClose}>
              OK
            </MDBBtn>
          </MDBModalFooter>
        </MDBModalContent>
      </MDBModalDialog>
    </MDBModal>
  );
};

// Hook to use MessageBox easily
export const useMessageBox = () => {
  const [show, setShow] = useState(false);
  const [message, setMessage] = useState('');
  const [title, setTitle] = useState('');
  const [type, setType] = useState('info');

  const showMessage = (msg, msgType = 'info', msgTitle = null) => {
    setMessage(msg);
    setType(msgType);
    setTitle(msgTitle || (msgType === 'success' ? 'Success' : msgType === 'error' ? 'Error' : msgType === 'warning' ? 'Warning' : 'Information'));
    setShow(true);
  };

  const hideMessage = () => {
    setShow(false);
  };

  const MessageBoxComponent = () => (
    <MessageBox
      show={show}
      onClose={hideMessage}
      title={title}
      message={message}
      type={type}
    />
  );

  return {
    showMessage,
    showSuccess: (msg, title) => showMessage(msg, 'success', title),
    showError: (msg, title) => showMessage(msg, 'error', title),
    showWarning: (msg, title) => showMessage(msg, 'warning', title),
    showInfo: (msg, title) => showMessage(msg, 'info', title),
    MessageBoxComponent
  };
};

export default MessageBox;

